// @flow

import { observer } from "mobx-react";
import React from "react";

import Video from "app/models/Video";

import TextFormatter from "app/util/TextFormatter";

import "./VideoTime.scss";

type Props = {
    video: Video
};

@observer
export default class VideoTime extends React.Component<Props> {
    formatTime(time: number) {
        return TextFormatter.seconds(time, true);
    }

    render() {
        return (
            <div className="VideoTime">
                {this.formatTime(this.props.video.duration)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoTime/VideoTime.js